import { getRequest } from "../../network/http"

const getListLocation = async (options?: any) => {
  return await getRequest('locations', { params: options || {} })
}

export { getListLocation }